import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import festival_photo from "../../components/images/usa/Tigray_festival_event_July_2023.jpg";
import save_mother from "../../components/images/save_mother_save_tigray.jpg";
import texas3 from "../../components/images/usa/TX-USA-003.jpg";
import certificates from "../../components/images/usa/2024_10_13_Picnic_Arlington_VA/2024-10-13-Rediet-picnic-03_appreciated.JPG";
import adishihu_training from "../../components/images/adishihu/adishihu_20231027_152359.jpg";
import enticho_training from "../../components/images/enticho/enticho_1973.jpg";
import hagereselam_training from "../../components/images/hagereselam/hagereselam_IMG_5309.JPG";
import mekelle_training from "../../components/images/mekelle/mekelle_IMG_20230323_095607.jpg";
import shire_training from "../../components/images/shire/shire_PHOTO-2023-05-18-11-50-36.jpg";
import usa_picnic_cooks from "../../components/images/usa/2024_10_13_Picnic_Arlington_VA/2024-10-13-Rediet-picnic-08_cooking_team.JPG";
import old_and_young from "../../components/images/usa/2024_10_13_Picnic_Arlington_VA/2024-10-13-Rediet-picnic-11-from-old-to-young.JPG";
import seble from "../../components/images/usa/2024_10_13_Picnic_Arlington_VA/2024-10-13-Rediet-picnic-06.JPG";
import Rediet_MW_FR_01 from "../../components/images/usa/Rediet-MFR01.jpg";
import Rediet_MW_FR_02 from "../../components/images/usa/Rediet-MFR02.jpg";
import Rediet_MW_FR_03 from "../../components/images/usa/Rediet-MFR03.jpg";
import Rediet_MW_FR_04 from "../../components/images/usa/Rediet-MFR04.jpg";
import Rediet_MW_FR_05 from "../../components/images/usa/Rediet-MFR05.jpg";
import Rediet_MW_FR_06 from "../../components/images/usa/Rediet-MFR06.jpg";
import Rediet_MW_FR_07 from "../../components/images/usa/Rediet-MFR07.jpg";
import Rediet_MW_FR_08 from "../../components/images/usa/Rediet-MFR08.jpg";
import Rediet_MW_FR_09 from "../../components/images/usa/Rediet-MFR09.jpg";
import Rediet_MW_FR_10 from "../../components/images/usa/Rediet-MFR10.jpg";
import Rediet_MW_FR_11 from "../../components/images/usa/Rediet-MFR11.jpg";

// 2026 Fund Raising Picnic - Arlington VA, USA
import group_photo from "../images/usa/2026Event/RedietFundRaisingEvent2026GroupPhoto.jpg";
import rediet_selling from "../images/usa/2026Event/RedietFundRaisingEvent2026SellingRedietProducts.jpg";
import board_chair from "../images/usa/2026Event/RedietFundRaisingEvent2026BoardChairSpeaking.jpg";
import food_service from "../images/usa/2026Event/RedietFundRaisingEvent2026FoodService.jpg";
import lottery_winner from "../images/usa/2026Event/RedietFundRaisingEvent2026LotteryWinner.jpg";
import painting_show from "../images/usa/2026Event/RedietFundRaisingEvent2026PaintingsShow.jpg";
import painting_competition from "../images/usa/2026Event/RedietFundRaisingEvent2026PaintingCompetition.jpg";
import walk from "../images/usa/2026Event/RedietFundRaisingEvent2026Walk.jpg";
import winner_painting from "../images/usa/2026Event/RedietFundRaisingEvent2026WinnerPainting.jpg";
import artist_guiding from "../images/usa/2026Event/RedietFundRaisingEvent2026ArtistGivingPaintingDirections.jpg";

import Anncouncements from "./Announcements";

// import "./temporary.css";

const LeftInner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [isSliding, setIsSliding] = useState(false);

  const images = [
    {
      src: festival_photo,
      description: (
        <>
          Selam Tesfay and Eldana Kibrom serving light refreshments during a
          Rediet fundraising event. <br />
          <br />
          July 2022, Washington DC
        </>
      ),
    },
    {
      src: save_mother,
      description: "Training taking place in Adigrat, Tigray",
    },
    {
      src: texas3,
      description: "Some of our Rediet members from Texas",
    },
    {
      src: certificates,
      description: (
        <>
          Exemplary kids - Eldana Kibrom, Arsema Negassi, and Makda Negassi{" "}
          <br />
          <br />
          Awarded Certificates of Appreciation by Rediet Board for their
          significant contributions in the fundrasing activities
        </>
      ),
    },
    {
      src: adishihu_training,
      description: "Training taking place in Adishihu, Tigray",
    },
    {
      src: enticho_training,
      description: "Training taking place in Enticho, Tigray",
    },
    {
      src: hagereselam_training,
      description: "Training taking place in Hagerselam, Tigray",
    },
    {
      src: mekelle_training,
      description: "Training taking place in Mekelle, Tigray",
    },
    {
      src: shire_training,
      description: "Training taking place in Shire, Tigray",
    },
    {
      src: seble,
      description:
        "Supporting the Cause: Seble selling her own produce for Rediet fundraising",
    },
    {
      src: usa_picnic_cooks,
      description: "Fundraiser picnic - the cooking team, Arlington VA",
    },
    {
      src: old_and_young,
      description:
        "Fundraiser picnic - all participating - young to old, Arlington VA",
    },
    {
      src: rediet_selling,
      description:
        "Fundraiser picnic - selling products, Arlington VA, Oct 2026",
    },
    {
      src: board_chair,
      description:
        "Fundraiser picnic - chair person making speech, Arlington VA, Oct 2026",
    },
    {
      src: food_service,
      description: "Fundraiser picnic - food service, Arlington VA, Oct 2026",
    },
    {
      src: lottery_winner,
      description: "Fundraiser picnic - lottery winner, Arlington VA, Oct 2026",
    },
    {
      src: painting_show,
      description: "Fundraiser picnic - painting show, Arlington VA, Oct 2026",
    },
    {
      src: painting_competition,
      description:
        "Fundraiser picnic - painting competition, Arlington VA, Oct 2026",
    },
    {
      src: walk,
      description: "Fundraiser picnic - walk, Arlington VA, Oct 2026",
    },
    {
      src: winner_painting,
      description:
        "Fundraiser picnic - winner's painting, Arlington VA, Oct 2026",
    },
    {
      src: artist_guiding,
      description:
        "Fundraiser picnic - artist giving painting directions, Arlington VA, Oct 2026",
    },
    {
      src: Rediet_MW_FR_01,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_02,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_03,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_04,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_05,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_06,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_07,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_08,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_09,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_10,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    {
      src: Rediet_MW_FR_11,
      description:
        "Fundraiser picnic - members and guests in action, Arlington VA, Sep 2025",
    },
    // Add as many as you want
    // 2026 Fund Raising Event - Arlington VA, USA
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsSliding(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setNextIndex((prev) => (prev + 1) % images.length);
        setIsSliding(false); // Start fade-in
      }, 1000); // Match the fade duration in CSS
    }, 5000); // 10 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="left-inner ">
      <Anncouncements />
      <div className="picture-desc">
        {/* <p>
          Selam Tesfay and Eldana Kibrom serving light refreshments during a
          Rediet fundraising event.
        </p> */}
        {/* <p>July 2022, Washington DC.</p> */}
      </div>
      <div className="image-rotator-container">
        <img
          src={images[currentIndex].src}
          width={`100%`}
          height={`auto`}
          className={`responsive slider-image ${isSliding ? "slide-out" : ""}`}
          alt="Selam and Eldana serving light refreshments"
        />
        <img
          src={images[nextIndex].src}
          alt="Next"
          className={`responsive slider-image ${
            isSliding ? "slide-in" : "hidden"
          }`}
        />
        <div className="picture-desc">
          <p>{images[currentIndex].description}</p>
          {/* <p>
            Selam Tesfay and Eldana Kibrom serving light refreshments during a
            Rediet fundraising event.
          </p>
          <p>July 2022, Washington DC.</p> */}
        </div>
      </div>
    </div>
  );
};

export default LeftInner;
